
import { useCallback, useEffect, useState } from 'react';

import { DefaultAlert } from 'twyne-new.ui'

import { useGlobalAuthStore } from '../../stores/global/auth.js';

const CHECK_INTERVAL = 1 * 60 * 1000 // 1 minute
const COUNTDOWN_INTERVAL = 1000 // 1 second
const SAFETY_BUFFER = 15 * 1000 // 15 seconds

export default function SystemCheck({ children }) {
  const { systemCheck } = useGlobalAuthStore()

  const [downtime, setDowntime] = useState(0)
  const [time, setTime] = useState(0)

  const fetchStatus = useCallback(async () => {
    const data = await systemCheck()
    const downtime = data?.downtime || 0
    setDowntime(downtime)
    setTime(Math.max(0, Math.floor((downtime - (Date.now() - SAFETY_BUFFER)) / 1000)))
  }, [systemCheck])

  useEffect(() => {
    const interval = setInterval(() => {
      fetchStatus()
    }, CHECK_INTERVAL)
    return () => clearInterval(interval)
  }, [fetchStatus])

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(time => {
        if (time > 1) return time - 1

        clearInterval(interval)
        fetchStatus()
        return 0
      })
    }, COUNTDOWN_INTERVAL)

    return () => clearInterval(interval)
  }, [fetchStatus, downtime])

  if (downtime) {
    return <div className="w-screen h-screen twy-bg-base flex justify-center items-center">
      <DefaultAlert variant="warning" title="Temporarily Unavailable" icon={false}>
        <p>We're currently unavailable for a short moment. This should take <Timer time={time} />.</p>
      </DefaultAlert>
    </div>
  }

  return <>
    {children}
  </>
}

function Timer({ time }) {
  const minutes = String(Math.floor(time / 60)).padStart(2, "0")
  const seconds = String(time % 60).padStart(2, "0")
  return <span>{minutes}m{seconds}s</span>
}
